import { authRoutes } from '@/pages/auth/AuthLayout';
import { dashboardRoutes } from '@/pages/dashboard/DashboardLayout';
import { helpRoutes } from '@/pages/help/HelpLayout';
import { publicRoutes } from '@/pages/public/PublicLayout';
import {
  homeRoute,
  invitationRoute,
  legacySubscriptionRoute,
  rootRoute,
} from './rootRoute';

export { rootRoute } from './rootRoute';

export const routeTree = rootRoute.addChildren([
  homeRoute,
  invitationRoute,
  legacySubscriptionRoute,
  publicRoutes,
  authRoutes,
  dashboardRoutes,
  helpRoutes,
]);
